import '@fontsource-variable/space-grotesk';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles/global.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Service worker solo nella versione pubblicata: in sviluppo la cache darebbe solo fastidi.
if (import.meta.env.PROD) void import('./pwa/register').then((m) => m.registerServiceWorker());
